var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueLightClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FLX_Close",
    "data-name": "FLX Close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12",
    fill: "#fff",
    stroke: "#4eabe9",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.25,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7746",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M2472,498.938l-12.517,12.517",
    transform: "translate(-2459.487 -498.938)",
    fill: "none",
    stroke: "#4eabe9",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M12.517,0,0,12.517",
    transform: "translate(12.517 0) rotate(90)",
    fill: "none",
    stroke: "#4eabe9",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLightClose);
export default __webpack_public_path__ + "static/media/blue_light_close.e7a6d6394afabeaa116cd7a4fd1f30fa.svg";
export { ForwardRef as ReactComponent };